import * as timeago from 'timeago.js';

function Feefo () {
  var self = this;

  this.init = function () {
    self.feefoUrl = 'https://api.feefo.com/api/10/reviews/';
    self.ajaxOptions = {
      crossDomain: true,
      data: {
        merchant_identifier: 'bonkers',
        origin: 'www.bonkers.ie',
        since_period: 'ALL',
        unanswered_feedback: 'include'
      },
      dataType: 'json',
      type: 'GET'
    };
    self.getSummary();
    self.getData();
  };

  this.productVertical = function () {
    var url = window.window.location.href;
    if (url.includes('insurance') || url.includes('serious-illness')) return 'team:lifeinsurance';
    if (url.includes('compare-gas-electricity-prices')) return 'team:energy';
    return null;
  };

  this.buildSlide = function (review) {
    var customerName = review.customer ? review.customer.display_name : 'Customer';
    var $slide = $('<a>', { class: 'review', href: '/reviews/', title: 'Feefo Review' });
    var $wrapper = $('<div>');

    var $text = $('<div>', { class: 'slide_content_text' });
    $text.append($('<h3>', { class: 'review__heading' }).text(review.service.title));
    $text.append($('<p>', { class: 'review__text' }).text(review.service.review));
    $wrapper.append($text);

    var $stars = $('<div>', { class: 'rating__stars' });
    var $emptyStars = $('<span>', { class: 'empty_stars' });
    var $fillStars = $('<span>', { class: 'fill_stars', width: self.ratingWidth(review.service.rating.rating) });
    for (var i = 0; i < 5; i++) {
      $emptyStars.append($('<i>', { class: 'fal fa-star', 'aria-hidden': true }));
      $fillStars.append($('<i>', { class: 'fas fa-star', 'aria-hidden': true }));
    }
    $stars.append($emptyStars);
    $stars.append($fillStars);
    $wrapper.append($('<p>', { class: 'review__customer' }).text(customerName));
    $wrapper.append($stars);
    $wrapper.append($('<span>', { class: 'review__time' }).text('- ' + timeago.format(review.last_updated_date)));
    $slide.append($wrapper);
    return $slide;
  };

  this.getData = function () {
    var tags = self.productVertical();
    var options = $.extend(true, {
      url: self.feefoUrl + 'service',
      data: {
        feefo_parameters: 'include',
        full_thread: 'exclude',
        page: 1,
        page_size: 2,
        rating: '5,4,3'
      }
    }, self.ajaxOptions);
    if (tags) options.data.tags = tags;
    $.ajax(options).done(self.showSlides);
  };

  this.getSummary = function () {
    var options = $.extend(true, { url: self.feefoUrl + 'summary/service' }, self.ajaxOptions);
    $.ajax(options).done(self.showSummary);
  };

  this.ratingWidth = function (rating) {
    return Math.ceil(20 * rating) + '%';
  };

  this.showSlides = function (data) {
    $.each(data.reviews, function (_index, review) {
      $('.rating__reviews').append(self.buildSlide(review));
    });
  };

  this.showSummary = function (data) {
    $('.average_score').text(data.rating.rating + ' out of 5!');
    $('.review_total').text(Intl.NumberFormat().format(data.meta.count));
    $('.fill_stars').css('width', self.ratingWidth(data.rating.rating));
    $('.star_rating').css('opacity', 1);
  };

  this.textLimit = function (str, len) {
    if (typeof str === 'undefined') {
      return '';
    }
    if (str.length <= len) {
      return str;
    }
    return (str.slice(0, len - 1) + '…');
  };
};

$(function () {
  new Feefo().init();
});
